import React from "react";
import { Alert, AlertTitle } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { SET_ERROR_PROMPT_SMP_DISRUPTION } from "../../../store/actionTypes/bplrt/smpActionType";

const DisruptionErrorPrompt = () => {
  const dispatch = useDispatch();

  const {
    isErrorPromptSMPDisruptionPage: isError,
    errorMessageSMPDisruptionPage: errorMessage,
  } = useSelector((state) => state.bplrtSmp);

  const handleClose = (event, reason) => {
    dispatch({ type: SET_ERROR_PROMPT_SMP_DISRUPTION, payload: false });
  };

  return (
    isError && (
      <Alert
        sx={{ my: 2 }}
        severity="error"
        variant="filled"
        onClose={handleClose}
      >
        <AlertTitle>{errorMessage}</AlertTitle>
      </Alert>
    )
  );
};

export default DisruptionErrorPrompt;
